
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import AccountCircleOutlinedIcon from '@mui/icons-material/AccountCircleOutlined';
import LockOpenOutlinedIcon from '@mui/icons-material/LockOpenOutlined';
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import { Button, IconButton } from '@mui/material';
import { useEffect, useRef, useState } from 'react';
import { Flip, ToastContainer, toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import { toast_config } from "./toastify/config";
import apiCumbres from '../axios/axios';
import { useNavigate } from 'react-router-dom';
import LoadingSpinner from '../Spinner';
import { useDispatch, useSelector } from "react-redux";
import { guardarToken } from "../Store/slicers/tokenAuth";
import { motion } from "motion/react";
import jwtDecode from "jwt-decode";
import { styleBtn, styleTfLogin } from './Styles';
import ReCAPTCHA from "react-google-recaptcha";
import EmailIcon from '@mui/icons-material/Email';
import SmartphoneIcon from '@mui/icons-material/Smartphone';
import NumbersIcon from '@mui/icons-material/Numbers';



const Login = () => {


    const tknAuth = useSelector((state) => state.tknAuth);

    const navigation = useNavigate()

    useEffect(() => {
        if (tknAuth.token) return navigation('/home')
    }, [])

    const dispatch = useDispatch()

    const [showPassword, setShowPassword] = useState(false);

    const handleTogglePassword = () => {
        setShowPassword(!showPassword);
    };

    const [credenciales, setCredenciales] = useState({ usr: '', contrasena: '' })
    const [credencialesCliente, setCredencialesCliente] = useState({ correo: '', tel: '', folio: '' })
    const [isLoading, setIsLoading] = useState(false)

    const captchaRef = useRef(null);
    const [captchaToken, setCaptchaToken] = useState(null);
    const [captchaValido, setCaptchaValido] = useState(false);
    const [tipoLogin, setTipoLogin] = useState("colaborador"); // o client

    


    const iniciarSesion = () => {

        if(tipoLogin === 'colaborador'){
            if (!credenciales.usr || !credenciales.contrasena) return toast.info('Tiene que ingresar usuario y contraseña para iniciar sesión', toast_config)
        }else{
            if (!credencialesCliente.correo || !credencialesCliente.tel || !credencialesCliente.folio) return toast.info('Tiene que ingresar correo, telefono y folio para iniciar sesión', toast_config)
        }

        

        if (!captchaValido) return;

        setIsLoading(true)

        const autenticar = async () => {
            try {

                const url = tipoLogin === 'colaborador' ? '/autenticacion' : '/autenticacion-cliente'
                const body = tipoLogin === 'colaborador' ? { ...credenciales, captchaToken } : { ...credencialesCliente, captchaToken }

                const autenticado = await apiCumbres.post(url, body, {
                    headers: {
                        'Accept': 'application/x-www-form-urlencoded',
                        'Content-Type': 'application/x-www-form-urlencoded',
                    }
                })
                //guardar en redux
                const decoded = jwtDecode(autenticado.data.token);
                decoded.token = autenticado.data.token
                decoded.modulos = autenticado.data.modulos

                dispatch(guardarToken(decoded))
                navigation('/home')
            } catch (error) {
                let msg_error = ''
                if (error.response) {
                    console.log(error.response)
                    if (error.response.data.error) {
                        msg_error = error.response.data.error
                    } else {
                        msg_error = 'Ocurrió un error al iniciar sesion, favor de volver a intentarlo!'
                    }
                } else {
                    console.log(error)
                    msg_error = 'No hay respuesta por parte del servidor!'
                }
                //mensaje de toastify
                setIsLoading(false)
                toast.error(msg_error, toast_config)
            }
        }

        autenticar()


    }

    const handleCredenciales = (e) => {
        if (e.target.name === 'usr') {
            e.target.value = e.target.value.toUpperCase()
        }
        const { name, value } = e.target


        setCredenciales((prevCred) => ({
            ...prevCred,
            [name]: value
        }))
    }

    const handleCredencialesCliente = (e) => {

        if (['folio', 'correo'].includes(e.target.name)) {
            e.target.value = e.target.value.toUpperCase()
        }

        const { name, value } = e.target

        setCredencialesCliente((prevCred) => ({
            ...prevCred,
            [name]: value
        }))
    }

    const onCaptchaChange = (token) => {
        setCaptchaToken(token);
        setCaptchaValido(!!token);
    };


    const cambiarTipoLogin = (e, tl) => {

        setTipoLogin(tl)
        setCredenciales({ usr: '', contrasena: '' })
        setCredencialesCliente({ correo: '', tel: '', folio: '' })

        // limpiar captcha (SIN desmontar)
        captchaRef.current?.reset();
        setCaptchaToken(null);
        setCaptchaValido(false);
    }

    

    return (
        <>
            <div className="bg-login d-flex align-items-center">
                <div className="container">
                    {isLoading ?
                        <LoadingSpinner />
                        : null}
                    <div className="row d-flex justify-content-center align-items-center">
                        <div className="col-md-12 col-lg-12">

                            <motion.div className="card border-0 shadow-lg overflow-hidden"
                                initial={{ opacity: 0, y: 40 }}
                                animate={{ opacity: 1, y: 0 }}
                                transition={{ duration: 0.4, ease: "easeOut" }}
                                style={{ borderRadius: '20px' }}>
                                <div className="row g-0">

                                    <motion.div className="col-md-6 p-5 d-flex flex-column justify-content-center"
                                        initial={{ opacity: 0, x: -50 }}
                                        animate={{ opacity: 1, x: 0 }}
                                        transition={{ duration: 0.4, ease: "easeOut", delay: 0.2 }}>


                                        <div className="text-center">
                                            <div className="d-flex justify-content-center mb-4">
                                                <Button
                                                    variant={tipoLogin === "colaborador" ? "contained" : "outlined"}
                                                    onClick={(e) => cambiarTipoLogin(e, "colaborador")}
                                                    sx={{ borderRadius: "20px 0 0 20px" }}
                                                >
                                                    Colaboradores
                                                </Button>

                                                <Button
                                                    variant={tipoLogin === "cliente" ? "contained" : "outlined"}
                                                    onClick={(e) => cambiarTipoLogin(e, "cliente")}
                                                    sx={{ borderRadius: "0 20px 20px 0" }}
                                                >
                                                    Clientes
                                                </Button>
                                            </div>
                                            <p className=" ">BIENVENIDO A</p>
                                            <motion.img
                                                src="/img/logincumbres.png"
                                                alt="login visual"
                                                className="w-25 h-25  img-fluid"
                                                initial={{ opacity: 0, scale: 0.8 }}
                                                animate={{ opacity: 1, scale: 1 }}
                                                transition={{ duration: 0.4, ease: "easeOut", delay: 0.3 }}
                                            />
                                            <motion.form
                                                initial={{ opacity: 0 }}
                                                animate={{ opacity: 1 }}
                                                transition={{ delay: 0.4, duration: 0.4 }}
                                            >
                                                {tipoLogin === "colaborador" ?
                                                    <>
                                                        <motion.div
                                                            className="mb-3"
                                                            initial={{ opacity: 0, y: 20 }}
                                                            animate={{ opacity: 1, y: 0 }}
                                                            transition={{ duration: 0.4, delay: 0.1 }}>
                                                            <TextField
                                                                value={credenciales.usr}
                                                                onChange={handleCredenciales}
                                                                required
                                                                name='usr'
                                                                variant="outlined"
                                                                placeholder="Usuario"
                                                                fullWidth
                                                                InputProps={{
                                                                    startAdornment: (
                                                                        <InputAdornment position="start">
                                                                            <AccountCircleOutlinedIcon sx={{ color: '#9e9e9e' }} />
                                                                        </InputAdornment>
                                                                    ),
                                                                    sx: {
                                                                        borderRadius: '50px', // Ovalado
                                                                        backgroundColor: '#fff',
                                                                    },
                                                                }}
                                                                sx={styleTfLogin}
                                                            />

                                                        </motion.div>

                                                        <motion.div
                                                            className="mb-3"
                                                            initial={{ opacity: 0, y: 20 }}
                                                            animate={{ opacity: 1, y: 0 }}
                                                            transition={{ duration: 0.4, delay: 0.2 }}>
                                                            <TextField
                                                                value={credenciales.contrasena}
                                                                onChange={handleCredenciales}
                                                                required
                                                                name='contrasena'
                                                                variant="outlined"
                                                                type={showPassword ? "text" : "password"}
                                                                placeholder="Contraseña"
                                                                fullWidth
                                                                InputProps={{
                                                                    startAdornment: (
                                                                        <InputAdornment position="start">
                                                                            <LockOpenOutlinedIcon sx={{ color: '#9e9e9e' }} />
                                                                        </InputAdornment>
                                                                    ),
                                                                    endAdornment: (
                                                                        <InputAdornment position="end">
                                                                            <IconButton onClick={handleTogglePassword} edge="end">
                                                                                {showPassword ? <VisibilityOff /> : <Visibility />}
                                                                            </IconButton>
                                                                        </InputAdornment>
                                                                    ),
                                                                    sx: {
                                                                        borderRadius: '50px', // Ovalado
                                                                        backgroundColor: '#fff',
                                                                    },
                                                                }}
                                                                sx={styleTfLogin}
                                                            />
                                                        </motion.div>
                                                    </>
                                                    :
                                                    <>
                                                        <motion.div
                                                            className="mb-3"
                                                            initial={{ opacity: 0, y: 20 }}
                                                            animate={{ opacity: 1, y: 0 }}
                                                            transition={{ duration: 0.4, delay: 0.1 }}>
                                                            <TextField
                                                                value={credencialesCliente.correo}
                                                                onChange={handleCredencialesCliente}
                                                                required
                                                                name='correo'
                                                                variant="outlined"
                                                                placeholder="Correo"
                                                                fullWidth
                                                                InputProps={{
                                                                    startAdornment: (
                                                                        <InputAdornment position="start">
                                                                            <EmailIcon sx={{ color: '#9e9e9e' }} />
                                                                        </InputAdornment>
                                                                    ),
                                                                    sx: {
                                                                        borderRadius: '50px', // Ovalado
                                                                        backgroundColor: '#fff',
                                                                    },
                                                                }}
                                                                sx={styleTfLogin}
                                                            />

                                                        </motion.div>

                                                        <motion.div
                                                            className="mb-3"
                                                            initial={{ opacity: 0, y: 20 }}
                                                            animate={{ opacity: 1, y: 0 }}
                                                            transition={{ duration: 0.4, delay: 0.2 }}>
                                                            <TextField
                                                                value={credencialesCliente.tel}
                                                                onChange={handleCredencialesCliente}
                                                                required
                                                                name='tel'
                                                                variant="outlined"
                                                                placeholder="Ultimos 4 Digitos Telefono"
                                                                fullWidth
                                                                InputProps={{
                                                                    startAdornment: (
                                                                        <InputAdornment position="start">
                                                                            <SmartphoneIcon sx={{ color: '#9e9e9e' }} />
                                                                        </InputAdornment>
                                                                    ),

                                                                    sx: {
                                                                        borderRadius: '50px', // Ovalado
                                                                        backgroundColor: '#fff',
                                                                    },
                                                                }}
                                                                sx={styleTfLogin}
                                                            />
                                                        </motion.div>

                                                        <motion.div
                                                            className="mb-3"
                                                            initial={{ opacity: 0, y: 20 }}
                                                            animate={{ opacity: 1, y: 0 }}
                                                            transition={{ duration: 0.4, delay: 0.3 }}>
                                                            <TextField
                                                                value={credencialesCliente.folio}
                                                                onChange={handleCredencialesCliente}
                                                                required
                                                                name='folio'
                                                                variant="outlined"
                                                                placeholder="Folio: Ej. CI-XXXXX o CG-XXXXX"
                                                                fullWidth
                                                                InputProps={{
                                                                    startAdornment: (
                                                                        <InputAdornment position="start">
                                                                            <NumbersIcon sx={{ color: '#9e9e9e' }} />
                                                                        </InputAdornment>
                                                                    ),

                                                                    sx: {
                                                                        borderRadius: '50px', // Ovalado
                                                                        backgroundColor: '#fff',
                                                                    },
                                                                }}
                                                                sx={styleTfLogin}
                                                            />
                                                        </motion.div>


                                                    </>
                                                }
                                                <div className="mb-3 d-flex justify-content-center">
                                                    <ReCAPTCHA
                                                        ref={captchaRef}
                                                        sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
                                                        onChange={onCaptchaChange}
                                                    />
                                                </div>
                                                <Button disabled={!captchaValido} variant='contained' fullWidth sx={styleBtn} onClick={iniciarSesion}>Entrar</Button>
                                            </motion.form>



                                        </div>


                                    </motion.div>


                                    <motion.div className="col-md-6 d-none d-md-block position-relative"
                                        initial={{ opacity: 0, x: 60 }}
                                        animate={{ opacity: 1, x: 0 }}
                                        transition={{ duration: 0.4, ease: "easeOut", delay: 0.4 }}
                                    >
                                        <img
                                            src="/img/loginderecha.png"
                                            alt="login visual"
                                            className="w-100 h-100 object-fit-cover"
                                        />

                                        {/* Texto superpuesto */}
                                        <div
                                            className="position-absolute text-white text-center"
                                            style={{
                                                top: "50%",          // centrado vertical
                                                left: "50%",         // centrado horizontal
                                                transform: "translate(-50%, -50%)",
                                                backgroundColor: "rgba(10, 37, 64, 0.7)", // opcional: fondo semitransparente
                                                padding: "20px",
                                                borderRadius: "20px",
                                            }}
                                        >
                                            <img src="/img/cumbresLogoff.png" alt="" className='w-25 h-25 object-fit-cover' />
                                            <h2>CUMBRES</h2>
                                            <p>Sistema administrativo</p>

                                        </div>

                                    </motion.div>
                                </div>
                            </motion.div>
                        </div>
                    </div>
                </div>
            </div>
            <ToastContainer
                transition={Flip}
                position="bottom-center"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="colored" />
        </>
    )

}


export default Login